import { render, staticRenderFns } from "./consult-info22.vue?vue&type=template&id=50b32a5c&scoped=true"
import script from "./consult-info22.vue?vue&type=script&lang=js"
export * from "./consult-info22.vue?vue&type=script&lang=js"
import style0 from "./consult-info22.vue?vue&type=style&index=0&id=50b32a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b32a5c",
  null
  
)

export default component.exports